// src/components/StatusTimeline.jsx
import React from "react";

const StatusTimeline = ({
    items = [],
    canCancel = false,
    cancelIcon = null,
    onCancel,
    onChangeSelect,
    onSubmit,
    selectValue,
    format = (v) => v,
    confirmText = "Подтвердить",
    selectPlaceholder = "Выбрать статус",
    className = ""
}) => {
    const options = items.filter((s) => !s.isCompleted);

    return (
        <div className={`stl ${className}`}>
            <div className="stl__list">
                {items.map((s, i) => (
                    <div key={s.type || i} className={`stl__step ${s.isCompleted ? "is-done" : ""}`}>
                        <div className="stl__dot" />
                        <div className="stl__content">
                            <div className="stl__date">{s.date ? format(s.date) : "—"}</div>
                            <div className="stl__text">{s.text}</div>
                        </div>
                        {canCancel && s.isCompleted && (
                            <button
                                type="button"
                                className="stl__cancel"
                                onClick={() => onCancel && onCancel(s)}
                                aria-label="Отменить"
                                title="Отменить"
                            >
                                {cancelIcon}
                            </button>
                        )}
                    </div>
                ))}
            </div>

            <div className="stl__controls">
                <div className="stl__selectWrap">
                    <select
                        className="stl__select"
                        value={selectValue ?? ""}
                        onChange={onChangeSelect}
                    >
                        <option value="">{selectPlaceholder}</option>
                        {options.map((s) => (
                            <option key={s.type} value={s.type}>
                                {s.type} {s.text}
                            </option>
                        ))}
                    </select>
                </div>
                <button type="button" className="stl__confirm" onClick={onSubmit}>
                    {confirmText}
                </button>
            </div>
        </div>
    );
};

export default StatusTimeline;
